export default __webpack_public_path__ + "static/media/nft.48f73241.png";